module.exports = __webpack_public_path__ + "img/cl.39168277.svg";